// @flow

import React, {Children} from 'react';
import {withCssModule, hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './table.component.module.styl';

import type {StatelessFunctionalComponent} from 'react';

const classNames = withCssModule(styles);
const classes = hashedClasses(styles);

/**
 * Headline component Props
 */
type HeadlineProps = {|
    /**
     * ClassName for Headline
     */
    mix?: string,
    /**
     * Table head cell top text
     */
    topCaption?: React$Node,
    /**
     * Table head cell caption
     */
    caption: React$Node,
    children?: React$Node,
|};

export const Headline: StatelessFunctionalComponent<HeadlineProps> = props => {
    const {mix = ''} = props;
    const headlineClasses = classNames(
        'table__headline',
        {[mix]: mix}
    );
    return (
        <div className={headlineClasses}>
            {props.topCaption ? <div className={classes.table__subtitle}>{props.topCaption}</div> : null}
            <div className={classes.table__title}>{props.caption}</div>
            {Children.count(props.children) ? <div className={classes.table__subtitle}>
                {props.children}
            </div> : null}
        </div>
    );
};
